import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "club-info-modal-description px-2" }, [
        _c("div", { staticClass: "text-h6 text--text mb-2" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("Что даёт клуб", _vm.options)) + "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-1 text--text" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "Возможность получить скидку 30% на консультацию у врача.",
                  _vm.options
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-h6 text--text mt-8 mb-2" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("Как получить купон и скидку", _vm.options)) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "b-club-list text-body-1 text--text" }, [
          _c("div", { staticClass: "b-club-list__item" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "Оплатите на сайте ПроДокторов 50% стоимости консультации по клубной цене",
                    _vm.options
                  )
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "b-club-list__item" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t("Получите клубный купон на скидку", _vm.options)
                ) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "b-club-list__item" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$t(
                    "В день визита оплачиваете в клинике оставшиеся 50%",
                    _vm.options
                  )
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-h6 text--text mt-8 mb-2" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("Как вступить в клуб", _vm.options)) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-body-1 text--text mb-4" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t(_vm.CLUB_MODAL_TEXT.useClubPrice, _vm.options)) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-h6 text--text mt-10 mb-4 px-2 mt-8" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("Вопросы и ответы", _vm.options)) + "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        VExpansionPanels,
        { staticClass: "px-2", attrs: { multiple: "" } },
        _vm._l(_vm.expansionPanel, function (item, index) {
          return _c(
            VExpansionPanel,
            { key: `${_vm.componentName}ExpansionItem${index}` },
            [
              _c(
                VExpansionPanelHeader,
                { attrs: { "expand-icon": _vm.vuetifyIcons.arrowDown } },
                [
                  _c("span", { staticClass: "text-body-1" }, [
                    _vm._v(_vm._s(_vm.$t(item.title, _vm.options))),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(VExpansionPanelContent, { staticClass: "text-body-1" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t(item.description, _vm.options)) +
                    "\n      "
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "mt-10 px-2" }, [
        _c(
          "div",
          { staticClass: "text-body-2 text-secondary--text text-center" },
          [
            _vm._v(
              "\n      © 2011 — " +
                _vm._s(_vm.nowYear) +
                ", ООО «МЕДРОКЕТ»‎\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-block text-body-2 text-secondary--text mt-2 text-center",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("Оплачивая, вы соглашаетесь", _vm.options)) +
                "\n      " +
                _vm._s(_vm.$t("с", _vm.options))
            ),
            _c(
              "a",
              {
                staticClass: "text-secondary--text",
                attrs: {
                  href: _vm.pdfData.coupon,
                  rel: "noopener noreferrer",
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.$t("офертой", _vm.options)))]
            ),
            _vm._v("\n      " + _vm._s(_vm.$t("и", _vm.options))),
            _c(
              "a",
              {
                staticClass: "text-secondary--text",
                attrs: {
                  href: _vm.pdfData.participation,
                  rel: "noopener noreferrer",
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.$t("правилами клуба", _vm.options)))]
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }